import { RadioGroup } from 'components/RadioGroup'
import Styles from 'screens/VirtualMarketerOnboarding/CustomizeSchedule/CustomizeSchedule.module.scss'
import { ChipRadioButton } from 'components/RadioGroup/ChipRadioButton'
import { RadioGroupProps } from 'components/RadioGroup/Types'
import cx from 'classnames'
import { useField } from 'formik'
import { CrosspostFrequency } from 'types'

interface Props extends Omit<RadioGroupProps, 'onChange' | 'value'> {
  chipSize?: 'lg' | 'xs' | 'sm' | 'md'
  chipClassName?: string
  onChange?: (value: CrosspostFrequency) => void
  value: CrosspostFrequency
}

export const CrosspostFrequencyRadioGroup = (props: Props) => {
  const { onChange, chipSize, chipClassName, ...rest } = props
  const chipProps = {
    className: cx(Styles.chip, chipClassName),
    deletable: false,
    variant: 'flat' as const,
    size: chipSize,
  }

  return (
    <RadioGroup
      onChange={(value) => {
        value && onChange?.(value as CrosspostFrequency)
      }}
      {...rest}
    >
      <ChipRadioButton value="always" {...chipProps}>
        Always
      </ChipRadioButton>
      <ChipRadioButton value="sometimes" {...chipProps}>
        Sometimes
      </ChipRadioButton>
      <ChipRadioButton value="never" {...chipProps}>
        Never
      </ChipRadioButton>
    </RadioGroup>
  )
}

export const FormikDailyFrequencyRadioGroup = (props: Omit<Props, 'onChange' | 'value'> & { name: string }) => {
  const [field, , { setValue }] = useField<CrosspostFrequency>(props.name)

  return <CrosspostFrequencyRadioGroup {...props} value={field.value} onChange={setValue} />
}
